import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';

import archesSmall from 'assets/img/archesSmall.svg';
import helpIcon from 'assets/img/helpIcon.svg';
import bellIcon from 'assets/img/bellIcon.svg';
import { GlassesIcon, HomeIcon, InfoIcon } from 'components/SvgIcons';
import { useSelector } from 'store';
import { useSystemSettings } from 'providers/SystemSettingsProvider';

import UserDetails from './components/UserDetails/UserDetails';

import './Header.scss';

export interface HeaderProps {
  homeLink?: string;
}

const Header: FC<HeaderProps> = ({ homeLink = '/dashboard' }: HeaderProps) => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
  const { logo_image, portal_name, user_guide, show_portal_name_next_to_logo, tickets_enabled, header_links } =
    useSystemSettings();

  return (
    <header className="enkrateia-header">
      <Link to={homeLink} className="logo">
        <img src={logo_image} alt={portal_name} />
        {show_portal_name_next_to_logo && <h2 className="title">{portal_name}</h2>}
      </Link>
      <nav>
        {t('common.header.home') !== '' && (
          <NavLink className="nav-element" to={homeLink}>
            <HomeIcon size={24} color="#05445E" />
            {t('common.header.home')}
          </NavLink>
        )}
        {header_links.map((link) => (
          <a
            className="nav-element"
            href={link.target}
            key={link.id}
            target={link.external ? '_blank' : '_self'}
            rel="noopener noreferrer"
          >
            {link.icon && <img src={link.icon} width={28} height={28} alt="icon" />}
            {link.name}
          </a>
        ))}
        {isLoggedIn && tickets_enabled && (
          <NavLink className="nav-element" to="/tickets">
            <GlassesIcon size={28} color="#05445E" />
            {t('common.header.tickets')}
          </NavLink>
        )}
        {t('common.header.aboutArchesUrl') !== '' && (
          <a className="nav-element" href={t('common.header.aboutArchesUrl')} target="_blank" rel="noreferrer">
            <img src={archesSmall} alt="Arches" />
            {t('common.header.aboutArches')}
          </a>
        )}
        {t('common.header.aboutTraroUrl') !== '' && (
          <a className="nav-element" href={t('common.header.aboutTraroUrl')} target="_blank" rel="noreferrer">
            <InfoIcon size={24} color="#05445E" />
            {t('common.header.aboutTraro')}
          </a>
        )}
        {user_guide && (
          <a className="nav-element" href={user_guide} target="_blank" rel="noreferrer">
            <img src={helpIcon} alt="Helps" />
            {t('common.header.userGuide')}
          </a>
        )}
        {isLoggedIn && (
          <>
            <div className="nav-element">
              <img src={bellIcon} alt="Bell" />
            </div>
            <UserDetails />
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
